import script from "./QuoteEmailForm.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteEmailForm.vue?vue&type=script&setup=true&lang=js"

import "./QuoteEmailForm.vue?vue&type=style&index=0&id=e74cc592&scoped=true&lang=scss"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e74cc592"]])

export default __exports__